<template>
  <div
    id="app"
    class="wrapper"
    style="
      padding-right: 2px;
      padding-left: 2px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      height: 100%;
    "
  >
    <div class="content-wrapper">
      <ul v-if="this.lojas.length > 0">
        <li v-for="loja in lojas" v-bind:key="loja.cd">
          <button
            :style="{ backgroundColor: corBotao, color: corTexto }"
            class="buttonLoja"
            @click="handleChooseLoja(loja.cd)"
          >
            {{ loja.nm }}
          </button>
          <img
            v-bind:src="urlImage(retornaContrato, loja.nm)"
            @error="erroImagem($event)"
            @click="handleChooseLoja(loja.cd)"
            :class="loja.nm.split(' ').join('')"
            :id="loja.nm"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Inis from "../services/inis";
import Loja from "../services/loja";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Loja",
  data() {
    return {
      corFundo: "",
      corBotao: "",
      corTexto: "",
      lojas: [
        {
          nm: "",
          cd: "",
          ativo: "",
        },
      ],
      contrato: "",
    };
  },
  computed: {
    listandoInis() {
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corFundo = response.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corBotao = response.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((response) => {
        this.corTexto = response.data[0].vl;
      });
    },
    retornaContrato() {
      this.contrato = parseInt(process.env.VUE_APP_CONTRATO);

      return this.contrato;
    },
    ...mapGetters({
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    handleChooseLoja(cd) {
      this.$store.commit("setLoja", cd);
      this.$router.push("/");
    },
    urlImage(contrato, classe) {
      let encodedNm = Buffer.from(classe).toString("base64");
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/lojas/${encodedNm}.jpg?${performance.now()}`;
    },
    erroImagem(e) {
      var loja = e.target.id;
      document.querySelector("." + loja.split(" ").join("")).remove();
    },
    listarLojas() {
      Loja.listarloja().then((resposta) => {
        this.lojas = resposta.data;
      });
    },
    ...mapActions(["addToCart"]),
  },
  mounted() {
    this.listarLojas();
    this.listandoInis();
  },
};
</script>
<style scoped>
.buttonLoja {
  width: 100%;

  text-align: center;
  font-size: 2rem;
  background-color: #960000;
  color: #fff;
  border-radius: 10px;
  padding: 5px;
  margin-top: 5px;
}
</style>
